export const State = [
    {
    name: "AN",
    value: "Andaman and Nicobar Islands"
    },
    {
    name: "AP",
    value: "Andhra Pradesh"
    },
    {
    name: "AR",
    value: "Arunachal Pradesh"
    },
    {
    name: "AS",
    value: "Assam"
    },
    {
    name: "BR",
    value: "Bihar"
    },
    {
    name: "CG",
    value: "Chandigarh"
    },
    {
    name: "CH",
    value: "Chhattisgarh"
    },
    {
    name: "DH",
    value: "Dadra and Nagar Haveli"
    },
    {
    name: "DD",
    value: "Daman and Diu"
    },
    {
    name: "DL",
    value: "Delhi"
    },
    {
    name: "GA",
    value: "Goa"
    },
    {
    name: "GJ",
    value: "Gujarat"
    },
    {
    name: "HR",
    value: "Haryana"
    },
    {
    name: "HP",
    value: "Himachal Pradesh"
    },
    {
    name: "JK",
    value: "Jammu and Kashmir"
    },
    {
    name: "JH",
    value: "Jharkhand"
    },
    {
    name: "KA",
    value: "Karnataka"
    },
    {
    name: "KL",
    value: "Kerala"
    },
    {
    name: "LD",
    value: "Lakshadweep"
    },
    {
    name: "MP",
    value: "Madhya Pradesh"
    },
    {
    name: "MH",
    value: "Maharashtra"
    },
    {
    name: "MN",
    value: "Manipur"
    },
    {
    name: "ML",
    value: "Meghalaya"
    },
    {
    name: "MZ",
    value: "Mizoram"
    },
    {
    name: "NL",
    value: "Nagaland"
    },
    {
    name: "OR",
    value: "Odisha"
    },
    {
    name: "PY",
    value: "Puducherry"
    },
    {
    name: "PB",
    value: "Punjab"
    },
    {
    name: "RJ",
    value: "Rajasthan"
    },
    {
    name: "SK",
    value: "Sikkim"
    },
    {
    name: "TN",
    value: "Tamil Nadu"
    },
    {
    name: "TS",
    value: "Telangana"
    },
    {
    name: "TR",
    value: "Tripura"
    },
    {
    name: "UK",
    value: "Uttar Pradesh"
    },
    {
    name: "UP",
    value: "Uttarakhand"
    },
    {
    name: "WB",
    value: "West Bengal"
    }
]


